import { PageShell, PlaceholderCard } from '../layout/page-shell.jsx';

/**
 * Stage-1.1 placeholder pages. Each page is a real page-shell with a "coming soon"
 * card so the layout, header, and routing are wired end-to-end. Subsequent stage-1
 * milestones will replace these with real implementations.
 */

export function DashboardPage() {
  return (
    <PageShell
      icon="fa-gauge-high"
      title="Dashboard"
      subtitle="System overview, node health, recent activity"
    >
      <PlaceholderCard
        icon="fa-gauge-high"
        title="Dashboard arrives in §1.13"
        description="Aggregate view of node status, channels, users, CA health, and the most recent audit events."
      />
    </PageShell>
  );
}

export function PwaPage() {
  return (
    <PageShell
      icon="fa-cloud-arrow-down"
      title="Install PWA"
      subtitle="Offline-capable progressive web app"
    >
      <PlaceholderCard
        icon="fa-cloud-arrow-down"
        title="PWA arrives in §1.15"
        description="Final stage-1 milestone. Implements install/update flow per pwa-install-update-spec.md."
      />
    </PageShell>
  );
}
